<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="900" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title primary-title class="pa-2 pl-3">
          {{ $t("oneAccount.titleEdit") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="text-align: center; padding-top: 40px">
          <v-layout row wrap justify-center align-center>
            <v-flex xs10 lg8 md10>
              <v-text-field
                :label="$t('dashboard.name')"
                v-model="NameTh"
                dense
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="justify-content: center" class="pb-5">
          <v-btn color="#077893" dark dense @click="fn_save()">
            {{ $t("smtp.text12") }}
          </v-btn>
          <v-btn color="red" text @click="close()">
            {{ $t("smtp.text11") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import authorization from "@/functions/authorization.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_item"],
  data: function () {
    return {
      NameTh: "",
      BusinessId: "",
      OneAccountId: "",
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogEdit");
        }
      },
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.NameTh = this._item.NameTH;
      }
    },
  },
  methods: {
    async fn_save() {
      var payload = {
        NameTH: this.NameTh,
        BusinessId: this._item.BusinessId,
        AccountId: this.$cookies.get("OneAccountId"),
        OneAccountID: this._item.AccountId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/EditOneAccount",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loading = false;

          if (response.data.Status === "OK") {
            this.$emit("closeDialogEdit");
            this.$emit("reData");
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    close() {
      this.$emit("closeDialogEdit");
    },
  },
};
</script>
